import { atomWithReset } from 'jotai/utils';

import { type CountryFilters, INITIAL_COUNTRY_FILTERS } from '../../types/countryFilters';

/**
 * Átomo com o estado dos filtros (client-side) da listagem de Países.
 *
 * Deve ser consumido apenas via `useCountryFilters` (CLAUDE.md proíbe `useAtom`
 * direto em componentes). Resetável via `useResetAtom`.
 */
export const countryFiltersAtom = atomWithReset<CountryFilters>(INITIAL_COUNTRY_FILTERS);
